import * as types from '../actions/dsr-invite-actions-types';


// Get Public DSR Config
const INITIAL_STATE_GET_DSR_INVITE_LINK = {
	isLoading: false,
	results: {},
	error: '',
};

export function getDsrInviteLinkReducer(state = INITIAL_STATE_GET_DSR_INVITE_LINK, action) {
	switch (action.type) {
		case types.GET_DSR_INVITE_LINK_RESET:
			return INITIAL_STATE_GET_DSR_INVITE_LINK;
		case types.GET_DSR_INVITE_LINK_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case types.GET_DSR_INVITE_LINK_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case types.GET_DSR_INVITE_LINK_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to get DSR invite link for specific user' };
		default:
			return state;
	}
}